import { today } from '@squadcore/api/shared/time'
import { createFileRoute } from '@tanstack/react-router'
import { CalendarPage } from '~/features/calendar/CalendarPage'
import { calendarRange, type CalendarSearch } from '~/features/calendar/search'
import { calendarQuery } from '~/features/calendar/queries'
import { loaderScope } from '~/lib/session'

const isDate = (v: unknown): v is string => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)

export const Route = createFileRoute('/_app/training/kalender')({
  validateSearch: (s: Record<string, unknown>): CalendarSearch => ({
    ...(s.view === 'week' || s.view === 'list' ? { view: s.view } : {}),
    ...(isDate(s.date) ? { date: s.date } : {}),
    ...(typeof s.hide === 'string' && /^[a-z,]{1,40}$/.test(s.hide) ? { hide: s.hide } : {}),
  }),
  loaderDeps: ({ search }) => ({ view: search.view, date: search.date }),
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope) return
    const { from, to } = calendarRange(deps.view ?? 'month', deps.date ?? today(scope.timezone))
    await context.queryClient.ensureQueryData(calendarQuery(scope.teamId, scope.season, from, to)).catch(() => undefined)
  },
  component: function Calendar() {
    return <CalendarPage search={Route.useSearch()} />
  },
})
